<template>
	<div class="container">
		<headerBox :current="5"></headerBox>
		<bannerBox ref="bannerChild"></bannerBox>
		<div class="content_box">
			<Tabs value="name1">
				<Tab-pane label="从业人员库-招标代理从业人员资料" name="name1">
					<div class="box">
						<div class="cell_box">
							<div>
								<div>姓名：</div>
								<div>{{ryInfo.name}}</div>
							</div>
							<div>
								<div>证书编号：</div>
								<div>{{ryInfo.certno}}</div>
							</div>
							<div>
								<div>身份证号：</div>
								<div>{{ryInfo.sfz}}</div>
							</div>
							<div>
								<div>从业单位：</div>
								<div>{{ryInfo.dw}}</div>
							</div>
						</div>
						<div class="zs_box">
							<img :src="ryInfo.resource" alt="">
						</div>
					</div>
				</Tab-pane>
			</Tabs>
		</div>
		<footerBox></footerBox>
		<Back-top :height="100" :bottom="200">
			<div class="iconfont icon-shangjiantou"></div>
		</Back-top>
	</div>
</template>

<script>
	import bannerBox from '@/components/banner.vue'
	import headerBox from '@/components/header.vue'
	import footerBox from '@/components/footer.vue'
	import {
		getCyry
	} from '@/api/home/index'
	export default {
		name: 'home',
		components: {
			bannerBox,
			headerBox,
			footerBox,
		},
		data() {
			return {
				ryInfo: {},
				params:{}
			}
		},
		mounted() {
			if(this.$route.query.certno){
				this.params.certno = this.$route.query.certno;
			}
			if(this.$route.query.sfz){
				this.params.sfz = this.$route.query.sfz;
			}
			this.$refs["bannerChild"].locationList = ['从业人员', '从业人员库', '从业人员资料'];
			this.getCyry();
		},
		methods: {
			getCyry() {
				getCyry(this.params).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.ryInfo = res.result.records[0];
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .ivu-tabs-nav .ivu-tabs-tab {
		width: 200px;
		text-align: center;
		font-size: 18px;
	}

	.content_box {
		margin: 80px auto;
		max-width: 1000px;

		.box {
			display: flex;
			justify-content: center;
			align-items: center;

			.cell_box {
				margin-top: 20px;

				>div {
					display: flex;
					align-items: center;
					margin: 20px;
					font-size: 16px;

					>div:first-child {
						width: 100px;
						/*高度需要添加，不然文字下面会多出一些空隙*/
						text-align: justify;
						height: 20px;

						&::after {
							content: "";
							display: inline-block;
							width: 100%;
						}
					}

					>div:last-child {
						background-color: #D8D8D8;
						width: 320px;
						height: 40px;
						border-radius: 4px;
						display: flex;
						align-items: center;
						padding: 0 10px;
					}
				}
			}

			.zs_box {
				display: flex;
				margin-left: 30px;
				width: 300px;
				height: 100%;

				img {
					vertical-align: top;
					height: 100%;
					width: 100%;
				}
			}
		}

	}
</style>
